import {useMemo} from 'react';
import {RolePermissionType} from '../../../../backend/enums/role-permission-type';
import {useAuth} from '../../../../contexts/auth/context';
import {CareServicesViewMode} from './care-service-item';

export function useCareServicePermissions(mode: CareServicesViewMode) {
  const {hasWritePermission} = useAuth();

  const canWrite = useMemo(() => {
    switch (mode) {
      case 'senior':
        return hasWritePermission(RolePermissionType.Seniors_CareServices);
      case 'caregiver':
        return hasWritePermission(RolePermissionType.Team_Professionals_CareServices);
      case 'seniors':
        return hasWritePermission(RolePermissionType.Team_CareServices);
      default:
        return false;
    }
  }, [hasWritePermission, mode]);

  return canWrite;
}
